import Box from '@mui/material/Box';
import React from 'react';

import { styles } from './PointerCircle.styles';

export const PointerCircle = () => {
  return <Box sx={styles.pointerCircle} />;
};
